import { FunctionComponent } from 'react'
import { Box, Typography } from '@black-bear-energy/rucksack'
import { ConstructionStatusAPIResponse } from '@black-bear-energy/black-bear-energy-common'
import { ConstructionStatusChip } from '../common/ConstructionStatusChip'
import { Field } from './Field'
import { SiteRFPDetailCard } from './SiteRFPDetailCard'
import { formatTableDate } from '../helpers/formatTableDate'
import { displayActualOrEstimatedDate } from '../helpers/displayActualOrEstimatedDate'

interface ConstructionDetailCardProps {
  constructionName?: string | null
  constructionStartDate?: Date | null
  commercialOperationDate?: Date | null
  commercialOperationDateEstimate?: Date | null
  constructionStatus?: ConstructionStatusAPIResponse | null
}

export const ConstructionDetailCard: FunctionComponent<
  ConstructionDetailCardProps
> = ({
  constructionName,
  constructionStartDate,
  commercialOperationDate,
  commercialOperationDateEstimate,
  constructionStatus,
}) => {
  return (
    <SiteRFPDetailCard>
      <Typography variant="subtitle1">Construction Details</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Field label="Lead">{constructionName}</Field>
        <Field label="Start Date">
          {constructionStartDate && formatTableDate(constructionStartDate)}
        </Field>
        <Field label="COD">
          {displayActualOrEstimatedDate(
            commercialOperationDate,
            commercialOperationDateEstimate
          )}
        </Field>
        <Field label="Status">
          {constructionStatus && (
            <ConstructionStatusChip status={constructionStatus} />
          )}
        </Field>
      </Box>
    </SiteRFPDetailCard>
  )
}
